import { gql } from 'apollo-angular'

export const CREATE_SEAT_ALLOCATION = gql`
  mutation CreateSeatAllocation($subscriptionId: Int!, $userId: Int!) {
    createSeatAllocation(
      data: { subscription: $subscriptionId, user: $userId }
    ) {
      id
    }
  }
`
